import React from 'react';
import Image from 'next/image';
import { Button } from "@/components/ui/button";

const MultivacLogo = () => {
  return (
    <div className="flex flex-col items-center gap-1 py-2">
      <span className="text-xs text-muted-foreground">© 2025 Aitana ApS</span>
    </div>
  );
};

export default MultivacLogo;